import { GET, POST } from "config/api.config";
import { HOMEPAGE, USER } from "config/apiEndPoint";
import { array } from 'prop-types';
import "toastr/build/toastr.min.css";
import { toast } from 'react-toastify';


export const updateUserProfile = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.UPDATE_USER_PROFILE}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};

export const fecthUserList = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.USER_LIST}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};

export const fecthAccountExecutiveList = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.ACCOUNT_EXECUTIVE_LIST}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};

export const updateUserProfileFromList = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.EDIT_USER_PROFILE_FROM_LIST}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};

export const addUserProfileFromList = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.ADD_USER_PROFILE_FROM_LIST}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};

export const fetchAllNotificationList = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.NOTIFICATION_LIST}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};

export const fetchRegisterData = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.USER_REGISTER}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};

export const updateUserSettingsNotification = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.USER_SETTINGS_NOTIFICATION_SUBMIT}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};

export const fetchClientList = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.USER_CLIENT_LIST}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};

export const loginWithClient = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.LOGIN_WITH_CLIENT}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};


export const fecthJobDetailsSection = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.FETCH_JOB_DETAILS}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};

export const fetchApplyJobList = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.APPLY_JOB_LIST}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};

export const applyNow = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${USER.APPLY_NOW}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};